<template>
  <div class="home clearfix">
    <!-- 进来默认显示的奥林巴斯相机图 -->
    <div class="default" :class="{fadeOut:defaultClas}" v-show="defaultImg">
      <img src="../assets/image/defaultimg.jpg" />
    </div>
    <div class="logo" v-show="lstbaner">
      <img src="../assets/image/homelogo.png" alt />
    </div>
    <div class="leftbanner" v-show="lstbaner">
      <div class="homefixedfont">
        <img src="../assets/image/homefixedfont.png" />
      </div>
      <router-link
        tag="a"
        :to="{name:Jump}"
        style="    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 100%;
    height: 85%;
    z-index: 9999;"
      ></router-link>
      <div class="banBox">
        <div
          v-show="data.dis"
          :class="setClass(data.clas,index)"
          v-for="(data,index) in banlist"
          :key="index"
        >
          <img :src="data.url" alt @load="loadImage" />
          <div class="pageFont">
            <div class="largeFont">{{data.numPage}}</div>
            <div class="pageTotal">/03</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 轮播缩略 -->
    <div class="banerNav" v-show="lstbaner">
      <img src="../assets/image/homenavbj.png" class="bj" />
      <ul>
        <li :class="setnavClass(data.cls,index)" v-for="(data,index) in navList" :key="index">
          <img :src="data.url" alt />
        </li>
      </ul>
    </div>
    <div class="rightCon" v-show="lstbaner">
      <img src="../assets/image/home_menu.jpg" style="position:absolute;top:0;left:0;width:100%;" />
      <div class="cli">
        <span @mouseenter="hoverjtImg" @mouseleave="outImg" @click="prevBanner">
          <img :src="jtl" />
        </span>
        <span @mouseenter="hoverjtImg2" @mouseleave="outImg2" @click="nextBanner">
          <img :src="jtr" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      Jump: "bingheLink",
      defaultClas: false,
      defaultImg: true,
      lstbaner: false,
      banlist: [
        {
          clas: "ani1",
          to: "bingheLink",
          dis: true,
          url: require("../assets/image/homebanner1.jpg"),
          numPage: "01"
        },
        {
          clas: "ani2",
          to: "nanshanLink",
          dis: false,
          url: require("../assets/image/homebanner2.jpg"),
          numPage: "02"
        },
        {
          clas: "ani3",
          to: "pinkyLink",
          dis: false,
          url: require("../assets/image/homebanner3.jpg"),
          numPage: "03"
        }
      ],
      navList: [
        { url: require("../assets/image/home_nav1.jpg"), cls: true },
        { url: require("../assets/image/home_nav2.jpg"), cls: false },
        { url: require("../assets/image/home_nav3.png"), cls: false }
      ],
      jtl: require("../assets/image/homejtl.png"),
      jtr: require("../assets/image/homejtr.png"),
      // 定时器
      timer: null,
      temporary: null,
      // 轮播角标
      index: null,
      banerIndex: 0,
      time: 9500
    };
  },
  mounted() {
    this.temporary = setInterval(() => {
      if (this.defaultImg == false) {
        this.bannerStart();
      }
    });
  },
  components: {},
  methods: {
    // 判断图片加载是否完成
    loadImage() {
      setTimeout(() => {
        this.lstbaner = true;
        this.defaultClas = true;
      }, 500);
      setTimeout(() => {
        this.defaultImg = false;
      }, 1000);
    },
    // 默认图消失轮播开始
    bannerStart() {
      //当前的index
      // var index = 0;
      clearInterval(this.temporary);
      let index = 0;
      const banLength = this.banlist.length - 1;
      this.timer = setInterval(() => {
        if (index == banLength) {
          index = 0;
          this.baner(index);
        } else {
          index++;
          this.baner(index);
        }
      }, this.time);
    },
    // 循环添加每个class
    setClass(value, index) {
      let obj = {};
      // 这里是固定的死class名
      obj["listbox"] = true;
      //这是动态加载对应的class名
      // 当前显示的轮播加class名 不显示的就去掉class名
      if (this.banlist[index].dis == false) {
        obj[`${value}`] = this.banlist[index].dis;
        obj["fadeIn"] = this.banlist[index].dis;
        obj["fadeOut"] = !this.banlist[index].dis;
      } else {
        obj[`${value}`] = this.banlist[index].dis;
        obj["fadeIn"] = this.banlist[index].dis;
        obj["fadeOut"] = !this.banlist[index].dis;
      }
      return obj;
    },
    setnavClass(value, index) {
      let obj = {};
      obj["listbox"] = true;
      if (this.banlist[index].dis == false) {
        obj["fadeIn"] = this.banlist[index].dis;
        obj["fadeOut"] = !this.banlist[index].dis;
      } else {
        obj["fadeIn"] = this.banlist[index].dis;
        obj["fadeOut"] = !this.banlist[index].dis;
      }
      return obj;
    },
    // 自动轮播
    baner(index) {
      for (let key in this.banlist) {
        this.banlist[key].dis = false;
      }
      this.index = index;
      this.banlist[index].dis = true;
      this.Jump = this.banlist[index].to;
    },
    // 上一页
    prevBanner() {
      // 清楚定时器
      this.deleteInterval();
      for (let key in this.banlist) {
        this.banlist[key].dis = false;
      }
      const banLength = this.banlist.length - 1;
      if (this.index !== null) {
        if (this.index == 0) {
          this.index = banLength;
          this.banerIndex = this.index;
          this.banlist[this.index].dis = true;
          this.Jump = this.banlist[this.index].to;
        } else {
          this.index--;
          this.banerIndex = this.index;
          this.banlist[this.index].dis = true;
          this.Jump = this.banlist[this.index].to;
        }
      } else {
        if (this.banerIndex == 0) {
          this.banerIndex = banLength;
          this.banlist[this.banerIndex].dis = true;
          this.Jump = this.banlist[this.banerIndex].to;
        } else {
          this.banerIndex--;
          this.banlist[this.banerIndex].dis = true;
          this.Jump = this.banlist[this.banerIndex].to;
        }
      }
      // 创建定时器
      this.addInterval();
    },
    // 下一页
    nextBanner() {
      // 清楚定时器
      this.deleteInterval();
      for (let key in this.banlist) {
        this.banlist[key].dis = false;
      }
      const banLength = this.banlist.length - 1;
      if (this.index !== null) {
        if (this.index == banLength) {
          this.index = 0;
          this.banerIndex = this.index;
          this.banlist[this.index].dis = true;
          this.Jump = this.banlist[this.index].to;
        } else {
          this.index++;
          this.banerIndex = this.index;
          this.banlist[this.index].dis = true;
          this.Jump = this.banlist[this.index].to;
        }
      } else {
        if (this.banerIndex == banLength) {
          this.banerIndex = 0;
          this.banlist[this.banerIndex].dis = true;
          this.Jump = this.banlist[this.banerIndex].to;
        } else {
          this.banerIndex++;
          this.banlist[this.banerIndex].dis = true;
          this.Jump = this.banlist[this.banerIndex].to;
        }
      }
      this.addInterval();
    },
    // 鼠标点击完毕后添加定时器
    addInterval() {
      const banLength = this.banlist.length - 1;
      this.timer = setInterval(() => {
        if (this.banerIndex == banLength) {
          this.banerIndex = 0;
          this.baner(this.banerIndex);
        } else {
          this.banerIndex++;
          this.baner(this.banerIndex);
        }
      }, this.time);
    },
    // 清楚定时器
    deleteInterval() {
      clearInterval(this.timer);
      this.timer = null;
    },
    hoverjtImg() {
      this.jtl = require("../assets/image/homejt_onl.png");
    },
    outImg() {
      this.jtl = require("../assets/image/homejtl.png");
    },
    hoverjtImg2() {
      this.jtr = require("../assets/image/homejt_onr.png");
    },
    outImg2() {
      this.jtr = require("../assets/image/homejtr.png");
    }
  }
};
</script>
<style scoped>
/* @import url(../assets/css/home.css); */
@import url(../assets/css/home_ie.css);
</style>